/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import BasicStats from './basic-stats.component'
import DistrictIncome from './district-income.component'
import FoodContainer from './fullscreen/food-container.component'
import PSDFullScreen from './fullscreen/PSD-fullscreen.component'
import Road from './fullscreen/road-fullscreen.component'
import InvestProjects from './invest-projects.component'
import MediaMonitoring from './media-monitoring.component'
import PopulationDemand from './population-demand.component'
import PopulationDynamic from './population-dynamic.component'
import PSD from './PSD.component'
import { Filters, RightMenuContainer } from './index.styles'
import {
  IBudgetItem,
  IDistrictIncomeList,
  IMarker,
  IPopulationDemand,
  IPopulationDetails,
  IPopulationDynamic,
  IProductSufficiencyItem,
  IPSDItem,
  IRoadShare,
  ITaxStat,
} from '../../interfaces/snp.interface'
import { getGeneralInfo } from '../../requests/snp.request'
import { getLang, getSelfSufficiencyPercentage, isRegion, OBLAST_KATO } from '../../utils/helpers.utils'
import { Text } from '../text.component'
import InvestProjectsFullScreen from './fullscreen/invest-projects-fullscreen.component'
import Screening from './tabs/screening.component'
import SER from './fullscreen/ser.component'
import DistrictIncomeFullScreen from './fullscreen/district-income-fullscreen.component'
import InfrastuctureFullScreen from './fullscreen/infrastructure-fullscreen.component'
import { getMMData } from '../../requests/kato.request'
import PupulationDynamicFullScreen from './fullscreen/population-dynamic-fullscreen.component'
import TaxComponent from './tax.component'
import { ArrowLeft, ArrowRight, DeleteX, SubArrow } from '../../assets/icons'
import FinanceAid from './tabs/finance-aid.component'
import WageFund from './tabs/wage-fund.component'
import ArchiveDigitalization from './tabs/archive-digitalization.component'
import WeeklyIncome from './tabs/weekly-income.component'
import Livestock from './tabs/livestock.component'
import SnpInfo from './snp-info.component'
import Entrepreneurship from './tabs/entrepreneurship.component'
import Tourism from './tabs/tourism'
import Architecture from './tabs/architecture.component'
import Education from './tabs/education.component'
import PE from './tabs/PE.component'
import Energy from './tabs/energy.component'
import NaturalResources from './tabs/natural-resources.component'
import TestIframe from './tabs/test-iframe.component'
import DigitalPassport from './digital-passport.component'
import Coordination from './tabs/coordination.component'

interface IProps {
  selectedTab: string | null;
  setSelectedTab: (link: string | null) => void;
  selectedMarker: IMarker | null;
  selectedRegion: any;
  toggleShowLeftMenu: () => void;
  showLeftMenu: boolean;
  setShowLeftMenu: (show: boolean) => void;
}

const RightMenu: React.FC<IProps> = ({ selectedTab, setSelectedTab, selectedMarker, selectedRegion, toggleShowLeftMenu, showLeftMenu, setShowLeftMenu }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const { link, kato, tab } = useParams()
  const [basicStats, setBasicStats] = useState<any>(null)
  const [additionalStats, setAdditionalStats] = useState<any>([])
  const [districtIncome, setDistrictIncome] = useState<IDistrictIncomeList | null>(null)
  const [investProjects, setInvestProjects] = useState<any>([])
  const [populationDemand, setPopulationDemand] = useState<IPopulationDemand[]>([])
  const [psdData, setPsdData] = useState<IPSDItem[]>([])
  const gridRef = useRef<HTMLDivElement>(null);
  const [fontCoef, setFontCoef] = useState<number>(1);
  const [productSelfSufficiency, setProductSelfSufficiency] = useState<IProductSufficiencyItem[]>([]);
  const [budgetData, setBudgetData] = useState<IBudgetItem>();
  const [populationDynamicStats, setPopulationDynamicStats] = useState<IPopulationDynamic[]>([]);
  const [roadData, setRoadData] = useState<IRoadShare>({} as IRoadShare);
  const [mmData, setMMData] = useState<any>(null);
  const [populationDetails, setPopulationDetails] = useState<IPopulationDetails>();
  const [taxStats, setTaxStats] = useState<ITaxStat[]>([]);
  const [snpInfo, setSnpInfo] = useState<any>(null);

  const [fullScreen, setFullScreen] = useState<{
    isOpen: boolean;
    type: string | null;
  }>({
    isOpen: false,
    type: null,
  });

  const closeModal = () => {
    setIsOpen(false);
    setShowLeftMenu(true);
  };

  const handleFullScreen = (obj: any) => {
    setFullScreen(obj);
  };

  useEffect(() => {
    if (selectedTab) {
      if (tab && tab !== 'undefined') {
        navigate(`/${kato}/${selectedTab}/${tab}`)
      } else {
        navigate(`/${kato}/${selectedTab}`)
      }
    }
  }, [selectedTab])

  useEffect(() => {
    if (kato) {
      if (!selectedTab) {
        setSelectedTab('snp')
      }
    }
  }, [kato])

  useEffect(() => {
    link && setSelectedTab(link);
    setIsOpen(true)
    setFullScreen({ isOpen: false, type: null })
  }, [link])


  useEffect(() => {
    if (kato || selectedMarker) {
      setIsOpen(true);
      const val = kato;
      if (val) {
        getMMData(val).then((res) => {
          setMMData(res);
        })

        getGeneralInfo(+val).then((res) => {
          setSnpInfo(res);
          if (res.basicStats?.every((stat: any) => stat.previousYearVal === null || stat.currentYearVal === null || stat.increaseVal === null)) {
            setBasicStats([])
          } else {
            const grouped = res.basicStats?.filter((item: any) => item.type !== 'ADDITIONAL_STAT').reduce((acc: any, stat: any) => {
              if (!acc[stat.type]) {
                acc[stat.type] = [];
              }
              acc[stat.type].push(stat);
              return acc;
            }, {});

            const additionalStats = res.basicStats?.filter((item: any) => item.type === 'ADDITIONAL_STAT');

            const groupedAdditionalStats = additionalStats?.reduce((acc: any, stat: any) => {
              if (!acc[stat.additionalInfo?.[`type${getLang()}`]]) {
                acc[stat.additionalInfo?.[`type${getLang()}`]] = [];
              }
              acc[stat.additionalInfo?.[`type${getLang()}`]].push(stat);
              return acc;
            }, {})
            setBasicStats(grouped);
            setAdditionalStats(groupedAdditionalStats);
          }
          const sortedInvestProjects = res.budgetInvestmentProjectStats
            .sort((a: any, b: any) => b.totalPrice - a.totalPrice)
            .map((item: any) => ({ ...item, realizationDate: item.realizationDate ? item.realizationDate.split('T')[0].split('-').reverse().join('.') : '' }));
          setPopulationDemand(res.populationDemandStats)
          setInvestProjects(sortedInvestProjects)
          setDistrictIncome(res.districtIncomeStats)
          setPopulationDynamicStats(res.populationIncreaseDynamicStats.sort((a, b) => a.year - b.year))
          setPsdData(res.projectEstimateDocumentation)
          setProductSelfSufficiency(
            res.productSelfSufficiencyStats.map((item: IProductSufficiencyItem) => ({
              ...item,
              selfSufficiencyPercentage: +getSelfSufficiencyPercentage(item)
            })).sort((a, b) => b.selfSufficiencyPercentage - a.selfSufficiencyPercentage))
          setBudgetData(res.budgetStats)
          setRoadData(res.totalRoadShareStats)
          setPopulationDetails(res.populationDetailsStats)
          setTaxStats(res.taxStats)
        })
      }

      handleFullScreen({ setOpen: false, type: null });
    }
  }, [kato, fontCoef])

  const updateMaxWidth = () => {
    if (gridRef.current) {
      if (gridRef.current.clientWidth >= 1500 && gridRef.current.clientWidth < 2550) {
        setFontCoef(1.25);
      } else if (gridRef.current.clientWidth >= 2550) {
        setFontCoef(1.5);
      } else {
        setFontCoef(1);
      }
    }
  };

  useEffect(() => {
    updateMaxWidth();
  }, [gridRef, gridRef.current?.clientWidth, showLeftMenu])

  useEffect(() => {
    updateMaxWidth();

    const handleResize = () => {
      updateMaxWidth();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [gridRef]);

  return (
    <>
      {isOpen && kato && <RightMenuContainer isFull={!showLeftMenu} style={{ minHeight: fullScreen.isOpen ? 'calc(100vh)' : 'min-content' }}>
        <Filters>
          <div className="toggle" onClick={toggleShowLeftMenu}> <ArrowRight width={10} fill='var(--primary-color)' style={{ transform: showLeftMenu ? 'rotate(180deg)' : 'rotate(0deg)' }} /> </div>

          <div className='header-text'>
            {fullScreen.isOpen && <div className="close-icon" onClick={() => setFullScreen({ isOpen: false, type: null })}>
              <ArrowLeft />
            </div>}

            <Text fontWeight={500} color='var(--primary-color)' fontSize="1.125rem">
              {selectedTab && t(selectedTab)}
            </Text>

            {
              (fullScreen.isOpen || selectedTab === 'digital-passport') && <>
                <SubArrow />
                {selectedTab === 'digital-passport'
                  ? <Text fontWeight={400} color='var(--text-color)' fontSize="1.125rem">
                    {snpInfo?.generalInfo?.[`name${getLang()}`]}
                  </Text>
                  : <Text fontWeight={400} color='var(--text-color)' fontSize="1.125rem">
                    {t(`new-fields.${fullScreen.type}`)}
                  </Text>}
              </>
            }

          </div>

          <div className="close-icon" onClick={() => closeModal()}>
            <DeleteX width={12} height={12} />
          </div>

        </Filters>
        {
          fullScreen.isOpen ? <>
            {fullScreen.type === 'FOOD' && productSelfSufficiency && productSelfSufficiency.length > 0 && <FoodContainer data={productSelfSufficiency} />}
            {psdData && fullScreen.type === 'PSD' && <PSDFullScreen kato={selectedRegion.kato} />}
            {fullScreen.type === 'ROAD' && roadData && <Road data={roadData} />}
            {fullScreen.type === 'InvestProjects' && <InvestProjectsFullScreen data={investProjects} />}
            {fullScreen.type === 'SER' && basicStats && kato && <SER kato={kato} DATA={basicStats} />}
            {fullScreen.type === 'DistrictIncome' && <DistrictIncomeFullScreen kato={kato} />}
            {fullScreen.type === 'INFRASTRUCTURE' && <InfrastuctureFullScreen />}
            {fullScreen.type === 'population-dynamic' && populationDetails && <PupulationDynamicFullScreen populationDetails={populationDetails} populationDynamic={populationDynamicStats} />}
          </>
            : selectedTab === 'snp-info' ? <SnpInfo data={snpInfo} />
              : selectedTab === 'analytics' ? basicStats?.FOOD && fontCoef && <Screening fontCoef={fontCoef} foodData={basicStats.FOOD} />
                : selectedTab === 'finance-aid' ? <FinanceAid />
                  : selectedTab === 'wage-fund' ? <WageFund />
                    : selectedTab === 'tourism' ? <Tourism />
                      : selectedTab === 'archive-digitalization' ? <ArchiveDigitalization />
                        : selectedTab === 'entrepreneurship' ? <Entrepreneurship />
                          : selectedTab === 'architecture' ? <Architecture />
                            : selectedTab === 'education' ? <Education />
                              : selectedTab === 'PE' ? <PE />
                                : selectedTab === 'energy' ? <Energy />
                                  : selectedTab === 'natural-resources' ? <NaturalResources />
                                    : selectedTab === 'TEST-IFRAME' ? <TestIframe />
                                      : selectedTab === 'digital-passport' ? <DigitalPassport />
                                        : selectedTab === 'weekly-income' ? <WeeklyIncome />
                                          : selectedTab === 'livestock' ? <Livestock />
                                            : selectedTab === 'coordination' ? <Coordination />
                                              : !isRegion(+kato) ? <DigitalPassport />
                                                : <div className="grid" ref={gridRef}>
                                                  {isRegion(+kato) ? <>
                                                    {basicStats && additionalStats && <BasicStats kato={+kato} filtered={['SER']} handleFullScreen={handleFullScreen} basicStats={basicStats} additionalStats={additionalStats} />}

                                                    {psdData && <PSD handleFullScreen={handleFullScreen} data={psdData} />}
                                                    {
                                                      populationDynamicStats
                                                      && <PopulationDynamic handleFullScreen={handleFullScreen} data={populationDynamicStats} />
                                                    }

                                                    {budgetData && <InvestProjects budgetData={budgetData} handleFullScreen={handleFullScreen} />}
                                                    {basicStats && additionalStats && <BasicStats filtered={['FOOD']} handleFullScreen={handleFullScreen} basicStats={basicStats} additionalStats={additionalStats} />}
                                                    {basicStats && <BasicStats filtered={['INFRASTRUCTURE']} handleFullScreen={handleFullScreen} basicStats={basicStats} additionalStats={additionalStats} />}

                                                    {basicStats && <BasicStats filtered={['ROAD']} handleFullScreen={handleFullScreen} basicStats={basicStats} additionalStats={additionalStats} totalRoadShareStats={roadData} />}
                                                    {districtIncome && +kato !== OBLAST_KATO && <DistrictIncome kato={selectedRegion?.kato} handleFullScreen={handleFullScreen} data={districtIncome} />}
                                                    {+kato === OBLAST_KATO && taxStats && <TaxComponent handleFullScreen={handleFullScreen} data={taxStats} />}
                                                    {populationDemand && populationDemand.length > 0 && selectedRegion && <PopulationDemand kato={selectedRegion?.kato} data={populationDemand} />}
                                                    {<MediaMonitoring list={mmData} regionName={selectedRegion?.nameRu} />}

                                                  </>
                                                    :
                                                    <>
                                                      {basicStats && additionalStats && <BasicStats filtered={['FOOD']} handleFullScreen={handleFullScreen} basicStats={basicStats} additionalStats={additionalStats} />}
                                                      {populationDemand && populationDemand.length > 0 && selectedRegion && <PopulationDemand kato={selectedRegion?.kato} data={populationDemand} />}
                                                      {
                                                        populationDynamicStats && <PopulationDynamic handleFullScreen={handleFullScreen} data={populationDynamicStats} />
                                                      }
                                                      {basicStats && <BasicStats filtered={['INFRASTRUCTURE']} handleFullScreen={handleFullScreen} basicStats={basicStats} additionalStats={additionalStats} />}
                                                      {districtIncome && <DistrictIncome kato={selectedRegion?.kato} handleFullScreen={handleFullScreen} data={districtIncome} />}
                                                    </>
                                                  }
                                                </div>
        }

      </RightMenuContainer >
      }
    </>
  )
}

export default RightMenu